/**
 * @author ydoni
 * @description modal 안 테이블 메뉴 선택 버튼
 */
import Tabs from "components/atoms/tabs/Tabs";
import { Option } from "utils/options";

export interface Menus {
  label: string;
  value?: boolean;
}

type ModalSubMenuProps = {
  menus: Option[];
  currentMenu: number; //현재 메뉴 index
  onChange: (value: string) => void;
  blue?: boolean;
  subTitle?: boolean;
  isDisabled?: boolean;
};

function ModalSubMenu({
  menus,
  currentMenu,
  onChange,
  blue,
  subTitle,
  isDisabled,
}: ModalSubMenuProps): JSX.Element {
  return (
    <Tabs
      tabs={menus}
      onChangeTab={(value) => onChange(value)}
      currentTab={currentMenu.toString()}
    />
  );
}

export default ModalSubMenu;
